import React, { useState, useEffect } from 'react';
import ContactForm from './ContactForm';
import './LandingPage.css';
import frontImage from './front.JPG';

const LandingPage = () => {
  const [showForm, setShowForm] = useState(false);
  const [qrCode, setQrCode] = useState('');

  useEffect(() => {
    // Get QR code from URL params or generate one for direct visitors
    const urlParams = new URLSearchParams(window.location.search);
    const qr = urlParams.get('qr') || `DIRECT_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    setQrCode(qr);

    // Track visit without Content-Type header
    setTimeout(() => {
      fetch('https://hjjtpav7x0.execute-api.us-east-1.amazonaws.com/prod/track-visit', {
        method: 'POST',
        body: JSON.stringify({
          qrCode: qr,
          ipAddress: window.location.hostname
        })
      })
      .then(response => {
        console.log('Response status:', response.status);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        return response.json();
      })
      .then(data => console.log('Visit tracked:', data))
      .catch(error => {
        console.error('Error tracking visit:', error);
        console.error('Error details:', error.message, error.stack);
      });
    }, 1000);
  }, []);

  const handleReserveShowing = () => {
    setShowForm(true);
  };

  return (
    <div className="landing-page">
      {/* Header */}
      <header className="header">
        <div className="header-content">
          <div className="logo-space">
            {/* Logo space reserved */}
          </div>
          <div className="phone-number">
            <a href="tel:321-522-2149">Call Us: 321-522-2149</a>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero-section" style={{backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${frontImage})`}}>
        <div className="hero-content">
          <div className="hero-text">
            <h1>Your Rent Money Deserves Better</h1>
            
            <p>Why build your landlord's wealth when you could be building your own? Your monthly rent payment could be a mortgage payment on your own Apopka townhome. It's time to invest in yourself, not someone else's property.</p>
          </div>

          <div className="hero-media">
            <h2>SAME PAYMENT,<br />REAL OWNERSHIP.</h2>
            <video controls autoPlay muted poster="/media/front.JPG">
              <source src="/media/vid-01092025-1.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <button className="cta-button" onClick={handleReserveShowing}>
              Reserve My Personal Tour
            </button>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section">
        <h2>Your Future Home Awaits</h2>
        <div className="gallery-grid">
          <div className="gallery-item">
            <video controls poster="/media/vid-01092025-2-poster.jpg">
              <source src="/media/vid-01092025-2.mp4" type="video/mp4" />
            </video>
          </div>
          <div className="gallery-item">
            <img src="/media/livingroom.JPG" alt="Living Room" />
          </div>
          <div className="gallery-item">
            <img src="/media/kitchen.JPG" alt="Kitchen" />
          </div>
          <div className="gallery-item">
            <img src="/media/masterbedroom.JPG" alt="Master Bedroom" />
          </div>
          <div className="gallery-item">
            <img src="/media/masterbath.JPG" alt="Bathroom" />
          </div>
          <div className="gallery-item">
            <img src="/media/front.JPG" alt="Backyard" />
          </div>
        </div>
      </section>

      {/* Contact Form Modal */}
      {showForm && (
        <ContactForm 
          qrCode={qrCode}
          onClose={() => setShowForm(false)}
        />
      )}

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <p>&copy; 2025 Tap Innovations, LLC/Kimone Campbell/Brenae Robinson REALTOR®. All Rights Reserved.</p>
          <div className="footer-links">
            <a href="/privacy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            <span className="separator">|</span>
            <a href="/tos.html" target="_blank" rel="noopener noreferrer">Terms of Use</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
